import { Component } from '@opten/compiler/metadata/component';
import newGuid from '@opten/common/new-guid';
import { OnInit } from '@opten/compiler/metadata/lifecycle';
import hasClass from '@opten/dom/has-class';

@Component({ className: 'js-delegate-events', observe: true })
export class DelegateEvents implements OnInit {
	private observedEvents = ['click'];
	private attrKey = 'data-delegate-id';
	constructor(private element: HTMLElement) {

	}

	onInit(): void {
		if (this.element.hasAttribute(this.attrKey)) {
			const attrVal = this.element.getAttribute(this.attrKey);
			const others = Array.from(document.querySelectorAll('[data-delegate-id="' + attrVal + '"]'))
				.filter((o) => o !== this.element);
			for (const eventName of this.observedEvents) {
				this.element.addEventListener(eventName, (e) => {
					e.preventDefault();
					others.forEach((other) => {
                            const event = document.createEvent('HTMLEvents');
                            event.initEvent(eventName, false, true);
                            other.dispatchEvent(event);

					});
				});
			}
		} else {
			this.element.setAttribute(this.attrKey, newGuid());
		}
	}
}